import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../Configuration/firebase";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = async () => {
    try {
      const response = await fetch(
        "https://us-central1-one-address-53a06.cloudfunctions.net/sendPasswordResetEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        },
      );
      if (!response.ok) {
        throw new Error(`sendPasswordResetEmail returned ${response.status}`);
      }
    } catch (error) {
      console.error(
        "Custom password reset email failed, falling back to default:",
        error,
      );
      try {
        await sendPasswordResetEmail(auth, email);
      } catch (fallbackError) {
        console.error(
          "Fallback password reset email failed too:",
          fallbackError,
        );
        setMessage("Error sending password reset email.");
        return;
      }
    }
    setMessage(
      "If an account with that email exists, a password reset link has been sent!",
    );
  };

  const handleCancel = () => {
    navigate("/"); // Navigate back to the main page
  };

  return (
    <div
      className="container"
      style={{
        width: "80%",
        maxWidth: "400px",
        margin: "auto",
        paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
      }}
    >
      <h2>Forgot Password</h2>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        style={{
          width: "90%",
          padding: "10px 15px",
          marginBottom: "10px",
          borderRadius: "20px",
          border: "1px solid var(--border-color, #ccc)",
          backgroundColor: "var(--input-bg, #fff)",
          color: "var(--text-primary, #000)",
        }}
      />
      <button
        style={{
          padding: "10px",
          backgroundColor: "#4CAF50",
          color: "white",
          borderRadius: "5px",
          marginRight: "20px",
          border: "none",
        }}
        onClick={handlePasswordReset}
      >
        Reset Password
      </button>
      <button
        type="button"
        onClick={handleCancel}
        style={{
          backgroundColor: "gray",
          color: "white",
          padding: "10px",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Back to Login
      </button>
      <p>{message}</p>
    </div>
  );
};

export default ForgotPassword;
